__turbopack_context__.v({
  "addressAndDescriptionContainer": "UtxosCart-module__5bR9Zq__addressAndDescriptionContainer",
  "btc": "UtxosCart-module__5bR9Zq__btc",
  "cancelButton": "UtxosCart-module__5bR9Zq__cancelButton",
  "checkIcon": "UtxosCart-module__5bR9Zq__checkIcon",
  "container": "UtxosCart-module__5bR9Zq__container",
  "containerActionIcon": "UtxosCart-module__5bR9Zq__containerActionIcon",
  "containerActions": "UtxosCart-module__5bR9Zq__containerActions",
  "containerTitle": "UtxosCart-module__5bR9Zq__containerTitle",
  "description": "UtxosCart-module__5bR9Zq__description",
  "icon": "UtxosCart-module__5bR9Zq__icon",
  "infiniteScroll": "UtxosCart-module__5bR9Zq__infiniteScroll",
  "invalidAddress": "UtxosCart-module__5bR9Zq__invalidAddress",
  "networkAmount": "UtxosCart-module__5bR9Zq__networkAmount",
  "networkBody": "UtxosCart-module__5bR9Zq__networkBody",
  "networkContainer": "UtxosCart-module__5bR9Zq__networkContainer",
  "networkTitle": "UtxosCart-module__5bR9Zq__networkTitle",
  "root": "UtxosCart-module__5bR9Zq__root",
  "selectAboveRow": "UtxosCart-module__5bR9Zq__selectAboveRow",
  "selectAboveText": "UtxosCart-module__5bR9Zq__selectAboveText",
  "selectBelowRow": "UtxosCart-module__5bR9Zq__selectBelowRow",
  "selectContainer": "UtxosCart-module__5bR9Zq__selectContainer",
  "sendAddressContainer": "UtxosCart-module__5bR9Zq__sendAddressContainer",
  "sendAddressDescription": "UtxosCart-module__5bR9Zq__sendAddressDescription",
  "sendAddressInput": "UtxosCart-module__5bR9Zq__sendAddressInput",
  "submitButton": "UtxosCart-module__5bR9Zq__submitButton",
  "title": "UtxosCart-module__5bR9Zq__title",
  "usd": "UtxosCart-module__5bR9Zq__usd",
});
